// extracted by mini-css-extract-plugin
module.exports = {"projectLinksStyles":"components-ProjectLinks-styles__projectLinksStyles","projectLinksItemStyles":"components-ProjectLinks-styles__projectLinksItemStyles"};